import { Monogram, Flourish, GoldRule } from "./ornaments";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-gold/15 bg-navy-deep py-16 text-center" data-testid="footer">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <div className="mx-auto flex justify-center">
        <Monogram size={64} />
      </div>
      <p className="mt-6 font-script text-3xl text-gold-light sm:text-4xl" data-testid="footer-script">
        with pride, love & gratitude
      </p>
      <p className="mt-4 text-[11px] uppercase tracking-[0.3em] text-mist">
        Saturday, December 5 · Sarasota &nbsp;—&nbsp; Tuesday, December 15 · Miami
      </p>
      <GoldRule className="mt-8 justify-center" />
      <div className="mt-8 flex items-center justify-center gap-3 opacity-40">
        <Flourish className="w-24" />
        <Flourish className="w-24" flip />
      </div>
      <p className="mt-8 text-[10px] uppercase tracking-[0.25em] text-mist/60">
        In honour of Dr. Stephanie Darilus · Graduation Celebration
      </p>
    </div>
  </footer>
);
